import { type AxiosError, isAxiosError } from 'axios'

import {
  type SensitiveExpired,
  SensitiveExpiredMessageEnum,
} from '@redteclab/api/clients/bully'

export const isSensitiveLoginExpiredAxiosError = (
  error: unknown,
): error is AxiosError<SensitiveExpired> =>
  Boolean(
    isAxiosError<unknown>(error) &&
    error.response?.data &&
    typeof error.response.data === 'object' &&
    'message' in error.response.data &&
    error.response.data.message ===
      SensitiveExpiredMessageEnum.SensitiveLoginExpired,
  )
